var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('b-spinner',{staticClass:"align-middle",attrs:{"variant":"default","role":"status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }